<template>
    <div id="advanced-date-picker" :class="'selector-'+selector">
        <el-radio-group v-if="selector === 'radio'" v-model="mode" @change="modeChange" style="margin-right: 3px;">
            <el-radio-button label="month">月度</el-radio-button>
            <el-radio-button label="quarter">季度</el-radio-button>
            <el-radio-button label="year">年度</el-radio-button>
            <el-radio-button label="custom">自定义</el-radio-button>
        </el-radio-group>

        <el-select v-if="selector === 'select'" v-model="mode" @change="modeChange">
            <el-option label="月度" value="month"></el-option>
            <el-option label="季度" value="quarter"></el-option>
            <el-option label="年度" value="year"></el-option>
            <el-option label="自定义" value="custom"></el-option>
        </el-select>

        <!-- 月度选择器 -->
        <el-date-picker
            v-show="mode === 'month'"
            v-model="monthDate"
            @change="monthChange"
            type="month"
            value-format="yyyy-MM-dd"
            format="yyyy年 M月"
            placeholder="选择月度"
            :editable="false"
            style="width:180px;"
        >
        </el-date-picker>

        <!-- 季度选择器，根据月度改的，目前实现的方式比较trick
             后期看Element的支持或者再手写一个
         -->
        <el-date-picker
            ref="quarterPicker"
            v-show="mode === 'quarter'"
            v-model="quarterDate"
            @focus="quarterFocus"
            @change="quarterChange"
            type="month"
            value-format="yyyy-MM"
            format="yyyy年 M季度"
            placeholder="选择季度"
            :editable="false"
            style="width:180px;"
        >
        </el-date-picker>

        <!-- 年度选择器 -->
        <el-date-picker
            v-show="mode === 'year'"
            v-model="yearDate"
            @change="yearChange"
            type="year"
            value-format="yyyy-MM-dd"
            format="yyyy 年"
            placeholder="选择年度"
            :editable="false"
            style="width:180px;"
        >
        </el-date-picker>

        <el-date-picker
            v-show="mode === 'custom'"
            v-model="customDate"
            @change="customChange"
            type="daterange"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            style="width:auto;"
        >
        </el-date-picker>
    </div>

</template>

<script>
    import dayjs from 'dayjs'

    export default {
        components: {},
        props: {
            value: {
                default: ''
            },

            /**
             * 默认的模式
             * month、quarter、year、custom
             */
            defaultMode: {
                default: 'month'
            },

            /**
             * 模式切换的ui
             * radio: 单选按钮组
             * select: 下拉菜单
             */
            selector: {
                default: 'radio'
            }
        },

        data() {
            return {
                mode: '',
                monthDate: null,
                quarterDate: null,
                yearDate: null,
                customDate: null,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },

        watch: {
            defaultMode: {
                handler(v) {
                    this.mode = v
                },
                immediate: true
            }
        },

        methods: {
            monthChange(date) {
                let beforeDate = date
                let afterDate = beforeDate ? dayjs(date).endOf('month').format('YYYY-MM-DD'): null
                this.$emit('input', [beforeDate, afterDate])
                this.$emit('change', [beforeDate, afterDate])
            },
            quarterChange(date) {
                if (date) {
                    let year = dayjs(date).year()

                    let quarterArr = [
                        // 一季度 1月、2月、3月
                        [`${year}-01-01`, `${year}-03-31`],

                        // 二季度 4月、5月、6月
                        [`${year}-04-01`, `${year}-06-30`],

                        // 三季度 7月、8月、9月
                        [`${year}-07-01`, `${year}-09-30`],

                        // 四季度 10月、11月、12月
                        [`${year}-10-01`, `${year}-12-31`],
                    ]

                    let key = dayjs(date).month()
                    let quarter = quarterArr[key]
                    this.$emit('input', quarter)
                    this.$emit('change', quarter)
                } else {
                    this.$emit('input', [null, null])
                    this.$emit('change', [null, null])
                }
            },
            yearChange(date) {
                let beforeDate = date
                let afterDate = beforeDate ? dayjs(date).endOf('year').format('YYYY-MM-DD'): null
                this.$emit('input', [beforeDate, afterDate])
                this.$emit('change', [beforeDate, afterDate])
            },
            customChange(date) {
                let beforeDate = date && date[0] || null
                let afterDate = date && date[1] || null
                this.$emit('input', [beforeDate, afterDate])
                this.$emit('change', [beforeDate, afterDate])
            },

            modeChange() {
                this.monthDate = null
                this.quarterDate = null
                this.yearDate = null
                this.customDate = null
                this.$emit('input', [null, null])
                this.$emit('change', [null, null])
            },

            quarterFocus(e) {
                this.$nextTick(() => {
                    let $popover = e.popperJS._popper

                    $($popover).find('.el-picker-panel__content .el-month-table').html(`
                       <tbody class="el-quarter-table">
                        <tr>
                           <td>第一季度</td>
                           <td>第二季度</td>
                           <td>第三季度</td>
                           <td>第四季度</td>
                        </tr>
                        </tbody>
                    `)
                })
            }
        },
    }
</script>

<style lang="scss">
    @import '../style/const.scss';

    #advanced-date-picker {
        .el-range-input {
            width: 80px;
        }
        .el-range-separator {
            width: auto;
        }

        &.selector-select {
            display: flex;
            > .el-select {
                width: 90px;
                .el-input__inner {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }
                .is-focus .el-input__inner,
                .el-input__inner:focus {
                    border-color: #C0C4CC;
                }
            }
            .el-date-editor {
                .el-input__inner,
                &.el-input__inner {
                    //border-left: none;
                    margin-left: -1px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                }
            }
        }
    }

    .el-quarter-table {
        td {
            padding: 14px 0;
            &:hover{
                color: $color-theme;
            }
        }
    }
</style>
